import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Move } from 'lucide-react';
import cn from 'classnames';
import { useBreakpoint } from '../../../../hooks/use-breakpoint';
import './draggable-overview-panel.scss';

interface DraggableOverviewPanelProps {
  index: number;
  panelKey: string;
  isDragging: boolean;
  isDragOver: boolean;
  onDragStart: (index: number) => void;
  onDragOver: (e: React.DragEvent, index: number) => void;
  onDrop: (e: React.DragEvent, index: number) => void;
  onDragEnd: () => void;
  children: React.ReactNode;
}

const DraggableOverviewPanel: React.FC<DraggableOverviewPanelProps> = ({
  index,
  panelKey,
  isDragging,
  isDragOver,
  onDragStart,
  onDragOver,
  onDrop,
  onDragEnd,
  children
}) => {
  const navigate = useNavigate();
  const { id: tripId } = useParams<{ id: string }>();
  const { isMobile } = useBreakpoint();

  const handleClick = (e: React.MouseEvent) => {
    // Don't navigate if clicking drag handle or interactive elements
    const target = e.target as HTMLElement;
    if (
      target.closest('.drag-handle') ||
      target.closest('button') ||
      target.closest('a')
    ) {
      return;
    }

    navigate(`/app/trip/${tripId}/view/${panelKey}`);
  };

  return (
    <div
      className={cn('draggable-overview-panel', {
        'is-dragging': isDragging,
        'is-drag-over': isDragOver
      })}
      draggable={!isMobile}
      onDragStart={!isMobile ? () => onDragStart(index) : undefined}
      onDragOver={!isMobile ? (e) => onDragOver(e, index) : undefined}
      onDrop={!isMobile ? (e) => onDrop(e, index) : undefined}
      onDragEnd={!isMobile ? onDragEnd : undefined}
      onClick={handleClick}
    >
      <div
        className='drag-handle'
        title='Drag to reorder'
      >
        <Move size={16} />
      </div>
      <div className='panel-content'>{children}</div>
    </div>
  );
};

export default DraggableOverviewPanel;
